// export const baseUrl = 'http://192.168.1.162:1033'
// const baseUrl = 'http://192.168.1.162:1035/'
const baseUrl = 'https://luyi.zxkjnc.com/'

module.exports = {
    baseUrl
}
